import { emailRegex, htmlRegex } from "../constants/regexPatterns"

export const emailIsValid = email => {
    return emailRegex.test(email)
}

export const isHtml = (string) => {
    return htmlRegex.test(string)
}